module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external {"root":"ReactRedux","commonjs":"react-redux","commonjs2":"react-redux","amd":"react-redux"}
// module id = 13
// module chunks = 0